export const ROUTE_SCROLL_EXCEPTIONS = [
  // eslint-disable-next-line security/detect-unsafe-regex
  (pathname: string) => /^\/contracts\/\d+(\\?.*)?$/g.test(pathname),
  (pathname: string) =>
    // eslint-disable-next-line security/detect-unsafe-regex
    /^\/accreditation\/clinics\/\d+\/(tasks|standards)(\/\d+)?(\?.*)?$/g.test(
      pathname,
    ),
]
